import { IconNameEnum } from "../../../../components/Icon";
import { Tile } from "../../../../components/Tile";
import { Colors } from "../../../../utils/enums";

export interface INumberBannerProps {
  value: number;
  unit?: string;
  label: string;
  doesWeigh?: boolean;
}

export const PriceBanner: React.FC<INumberBannerProps> = ({ label, value, unit }) => {
  return (
    <>
      <Tile
        color={Colors.Border}
        icon={IconNameEnum.coin}
        value={`${value.toString()} ${unit}`}
        caption={label}
        valueFontSize="22px"
      />
    </>
  );
};
